import { defaultSiteSettings } from "@/lib/site-settings";

const fallbackSiteSettings = defaultSiteSettings();

export const siteConfig = {
  name: fallbackSiteSettings.societyName,
  description: fallbackSiteSettings.description,
  city: fallbackSiteSettings.city,
  locationUrl: fallbackSiteSettings.locationUrl,
  instagram: fallbackSiteSettings.instagram,
  facebook: fallbackSiteSettings.facebook,
  whatsapp: fallbackSiteSettings.whatsapp,
  nav: [
    { label: "Accueil", href: "/" },
    { label: "Prestations", href: "/prestations" },
    { label: "Réalisations", href: "/realisations" },
    { label: "Avis", href: "/avis" },
    { label: "Rendez-vous", href: "/rendez-vous" },
    { label: "Contact", href: "/contact" },
  ],
};
